import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { PAYMENTS_ACCOUNT_NUMBER_BASE_PATH } from '../../../../../../../../../features/payments/account-number/payments-account-number-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/account-number/_account-number')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'payments-account-number-list',
        label: 'Payments',
        to: PAYMENTS_ACCOUNT_NUMBER_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
